// 由于新消息的很多处理会在IM缓存和当前所在IM中都触发，因此把主要逻辑提取出来

import store from "@/store"
import Vue from 'vue'
import { deepCopy, JSONParse } from "_lib/utils/utils";
import { addTitleForLinksInHTMLString } from "_lib/utils/utilsStr";
import { getDownloadManagerInstance } from '_lib/utils/utilsRoom';
import emojiRender from '_lib/emoji/EmojiRender'
import { IM_MSG_TYPE, ORIGIN_MESSAGES_CACHE_LENGTH_LIMIT } from '@/common/constants/IM.ts'
import { processMarkdown } from '_lib/MarkdownTransfer'
import markdownToHtml from '_lib/MarkdownToHtml.js'
import EventBus from "_lib/EventBus";

/**
 * @description socket type5 send_message推送的数据处理封装，用于ImHandler(IM 和 private)和ImMsgHandler.vue(IM 缓存)
 * @param {Object} data ws推送的数据
 * @param {Object} cache_data 缓存的IM数据 或者 ImHandler中的this(vue实例)
 * @param {Boolean} isLocal 是否是本地发送的, ImHandler中会使用
 * @param {Function} cb privateIm.vue和IM.vue中会使用回调进行一些特殊处理
 */
export function imMessageHandler({ data, cache_data, isLocal, cb }) {
  let ws_data = data.data, that = cache_data
  let user_id = store.getters.user_info.user_id, is_vue = cache_data instanceof Vue
  // 推送是编辑消息，只需要更新这条消息的数据就可以
  if (ws_data.updated) {
    let index = that.origin_messages.findIndex(v => v.data.im_seq == ws_data.im_seq)
    if (index > -1) {
      ws_data.update_time = Date.now()
      ws_data = messageDataRestructure(ws_data)
      let message = that.origin_messages[index]
      const oldMsg = deepCopy(message)
      message.data = {
        ...message.data,
        ...ws_data,
      }
      message.data.update_time = Date.now()
      setKeyData(that.origin_messages, index, message, that)
      EventBus.$emit('Update_Msg_Field', {
        type: 'update_msg',
        msg: message,
        oldMsg
      }, that.type)
    }
    cb && cb()
    return
  }
  // 只要不是编辑消息，最后收到的消息推送就是消息列表中最新的
  that.newest_seq = ws_data?.im_seq

  // isHistoryMode状态时，origin_messages中不包含最新的一条消息，因此不需要更新origin_messages
  // 增加新消息数量即可
  if (that.isHistoryMode) {
    if (!isLocal) {
      that.newMsgNum++
    }
    return
  }

  // teamCard类型已废弃，不处理
  if (ws_data.msg_type == IM_MSG_TYPE.teamCard) {
    return
  }
  if (ws_data.user_id == user_id) {
    ws_data.is_me = true
  }
  // 计算时间分割线需要data上的timestamp参数
  ws_data.timestamp = data.timestamp
  ws_data = messageDataRestructure(ws_data)

  // 如果不是本地发送的消息，检查是否在loading的消息列表中
  // 如果!is_vue，说明是缓存处理，不需要处理loading
  if (!isLocal && is_vue) {
    let isScrollBottom = that.isScrollBottom()
    let index = null
    let loadingMsg = that.loadingImMsgs.find((v, i) => {
      index = i
      return v.data.heychat_ack_id == ws_data.heychat_ack_id
    })
    if (loadingMsg) {
      const oldMsg = deepCopy(loadingMsg)
      loadingMsg.data = {
        ...loadingMsg.data,
        ...ws_data,
        img: loadingMsg.data.img,
        cdn_img: ws_data.img,
      }
      let { url } = JSONParse(ws_data.msg)
      if (process.env.IS_CLIENT) {
        getDownloadManagerInstance().then(() => {
          window.downloadManager.updateUploadItem(loadingMsg.data.heychat_ack_id, ws_data.im_seq, url)
        })
      }
      setKeyData(loadingMsg.data, 'isLoading', false, that)
      setKeyData(loadingMsg.data, 'im_seq', ws_data.im_seq, that)
      setKeyData(loadingMsg, 'sequence', ws_data.im_seq, that)
      that.loadingImMsgs.splice(index, 1)
      const msg_index = that.origin_messages.findIndex(v => v.sequence == loadingMsg.sequence)
      
      if (msg_index > -1) {
        setKeyData(that.origin_messages, msg_index, loadingMsg, that)
        if (isScrollBottom && JSONParse(data?.data?.addition)?.scam) {
          // 因为诈骗提示是 ws 返回的，消息体的高度会升高，所以这里需要滚动一次
          // 事实上所有 ws 返回的内容会导致消息体变化的情况都需要滚动，但是现在已知只有诈骗这一种情况
          that.goToBottomHandler()
        }
        EventBus.$emit('Update_Msg_Field', {
          type: 'update_msg',
          msg: loadingMsg,
          replaceLoading: true,
          oldMsg
        }, that.type)
        that.handleInteractiveResult(data, true)
      }
      cb && cb()
      return
    }
  }
  if (ws_data.state == 2) {
    that.origin_messages.push({
      component: 'message-rejected'
    })
  } else if (isLocal) {
    that.origin_messages.push(data)
  } else {
    that.origin_messages.push({
      component: 'message-item',
      sequence: data.data?.im_seq || data.sequence,
      data: ws_data
    })
    // 只有当前展示的IM才需要处理交互表情的动画
    if (is_vue) {
      // 这里必须加setTimeout，因为在goToBottomHandler里触发的new_msg，messages有msg后更新才会生效
      setTimeout(() => {
        that.handleInteractiveResult(data)
      }, 0)
    }
  }
  if (is_vue) {
    if (that.isScrollBottom() || ws_data.is_me) {
      that.goToBottomHandler(false, data)
    } else {
      that.newMsgNum++
    }
  } else {
    // !isHistoryMode时会直接滚动到底部，不需要更新newMsgNum
    if (that.isHistoryMode) {
      that.newMsgNum++
    }
    that.origin_messages = that.origin_messages.slice(-ORIGIN_MESSAGES_CACHE_LENGTH_LIMIT)
  }
  cb && cb()
}
export function messageDataRestructure(v, deal_update = true) {
  // 客户端发出类型为1，需要处理表情
  if (v.msg_type === 1) {
    v.msg = emojiRender.replaceEmojiByTextName(v.msg)
  }
  // type=4为markdown格式，需要转化为html
  if ([IM_MSG_TYPE.markdown, 
      IM_MSG_TYPE.textAndImg,
      IM_MSG_TYPE.AtOrChannel,
      IM_MSG_TYPE.punishNotify
    ].indexOf(v.msg_type) >= 0) {
    v._origin_msg = v.msg
    // 替换数字后面的点为实体字符, 防止markdown解析错误
    v.msg = v.msg.replace(/(\d)\./g, '$1&#46;');
    v.msg = v.msg.replace(/\<br\>/g, '<p></p>\n\n');
    v.msg = replaceSpanToH(v.msg)
    // 去掉![](data:image/xxx+ "preload-img")
    v.msg = v.msg.replace(/!\[\]\(data:image\/.*? "preload-img"\)/g, '')
    let msg = markdownToHtml(v)
    const addition = JSONParse(v.addition)
    if (v.update_time && deal_update && !v.on_risk && !addition?.on_risk && (v.msg_type !== IM_MSG_TYPE.feedbackCard)) {
      try {
        let parser = new DOMParser()
        let doc = parser.parseFromString(msg, 'text/html')
        // 找到最后一个标签
        let lastPTag = doc.querySelector('body').lastElementChild
        let span = document.createElement('span')
        span.className = 'edited'
        span.textContent = ' (已编辑)'
        lastPTag.appendChild(span)
        // 将修改后的DOM对象转换回字符串
        msg = doc.body.innerHTML
      } catch (err) {
        console.log('catch update edited msg error', err);
      }
    }
    v.msg = addTitleForLinksInHTMLString(msg, v.links)
  }
  if (v.msg_type === IM_MSG_TYPE.channelAnc) {
    let anc = JSONParse(v.msg)
    v.msg = anc.content
    v.anc_id = anc.anc_id
    v.msg = markdownToHtml(v)
  } else if (v.msg_type === IM_MSG_TYPE.teamCard) {
    v.msg = handleTeamCard(v.msg)

  }
  if (Boolean(v.reply && v.reply.msg)) {
    if ([0, IM_MSG_TYPE.markdown, IM_MSG_TYPE.AtOrChannel].indexOf(v.reply.msg_type) >= 0) {
      let msg = markdownToHtml(v.reply)
      if (v.reply?.links?.length) [
        msg = addTitleForLinksInHTMLString(msg, v.reply.links)
      ]
      v.reply.msg = msg
    }
    if (v.reply.msg_type === IM_MSG_TYPE.teamCard) {
      v.reply.msg = '卡片消息'
    }
    if (v.reply.msg_type === IM_MSG_TYPE.channelAnc) {
      if (!v.reply.anc_id) {
        let anc = JSONParse(v.reply.msg)
        v.reply.msg = anc.content
        v.reply.anc_id = anc.anc_id
        v.reply.msg = markdownToHtml(v.reply)
      }
    }
  }
  if (v.reply) {
    if (v.reply.is_revoke) {
      v.processed_reply = '<span class="reply-revoke-text">此消息已被删除</span>'
    } else {
      v.processed_reply = processMarkdown(v.reply)
    }
  }
  v.emoji = v.emoji || []
  if (v.pin_msg && v.pin_msg.piner_id > 0) {
    v.pin_info = {
      is_pinned: v.pin_msg.piner_id > 0,
      piner_name: v.pin_msg?.piner_room_nickname || v.pin_msg?.piner_name
    }
  }
  return v
}

// 将span标签替换成h1、h2
function replaceSpanToH(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const spans = doc.querySelectorAll('span');
  let flag = false
  spans.forEach(span => {
    const fontSize = span.style.fontSize;
    let newElement;
    if (fontSize === '20px') {
      newElement = document.createElement('h1');
      flag = true
    } else if (fontSize === '19px') {
      newElement = document.createElement('h2');
      flag = true
    }

    if (newElement) {
      while (span.firstChild) {
        newElement.appendChild(span.firstChild);
      }
      span.parentNode.replaceChild(newElement, span);
    }
  });
  if (flag) {
    return doc.body.innerHTML;
  }
  return htmlString
}

function handleTeamCard(item) {
  item.tags = item.tags.filter(tag => tag.desc)
  let icon_list = []
  if (item.tags && item.tags.length) {
    let icons = item.tags.filter(item => item.icon)
    item.tags = item.tags.filter(item => !item.icon)
    icon_list = [...icon_list, ...icons.reverse()]
  }
  if (item.game_icon) {
    icon_list.push({ icon: item.game_icon })
  }
  item.icons = {
    show_more: Math.max(0, icon_list.length - 5),
    list: icon_list.splice(Math.max(icon_list.length - 5, 0), icon_list.length),
  }

  item.has_chat = 1

  if (item.requires) {
    item.requires = {
      have: Number(item.requires.have) - 1,
      need: Number(item.requires.need)
    }
    item.show_users = deepCopy(item.chat_info.users)
  } else {
    item.requires = {
      have: 0,
      need: 0
    }
  }
  return item
}

function setKeyData(data, key, value, instance) {
  if (instance?.$set) {
    instance.$set(data, key, value)
  } else {
    data[key] = value
  }
}

export function getLastUnreadText(time) {
  const date = new Date(time)
  return `${date.getMonth() + 1}月${date.getDate()}日 新消息`
}


/**
 * @description: 处理5004推送，更新消息中的链接卡片数据
 * @param {*} data
 * @param {*} origin_messages
 * @return {*}
 */
export function parseSocketLink (data, origin_messages) {
  if (!origin_messages || !origin_messages.length) return
  const links = data.data.links || []
  const index = origin_messages.findIndex(item => item.data?.im_seq == data.data.im_seq)
  if (index > -1) {
    const message = origin_messages[index]
    
    let msg = addTitleForLinksInHTMLString(message.data.msg, links)
    Vue.set(message.data, 'msg', msg)
    Vue.set(message.data, 'links', links)
    Vue.set(message.data, 'is_private_im', !!data.data.user_id)
  }
}

/**
 * @description: 处理5007推送，更新消息中的addition额外信息
 * @param {*} data
 * @param {*} origin_messages
 * @return {*}
 */
export function addMsgAddition(data, origin_messages, cb) {
  const index = origin_messages.findIndex(item => item.data?.im_seq === data.data.im_seq)
  if (index === -1) return

  const message = origin_messages[index]
  let additionReceived = data.data.addition
  let additionOriginal = message.data.addition

  let additionResult
  if (additionOriginal) {
    let a1 = JSONParse(additionReceived)
    let a2 = JSONParse(additionOriginal)
    let a = Object.assign({}, a2, a1)
    additionResult = JSON.stringify(a)
  } else {
    additionResult = additionReceived
  }

  if (additionResult) {
    Vue.set(message.data, 'addition', additionResult)
    cb && cb()
  }
}

// 删除某个用户的全部消息
export function deleteAllUserMsgs ({user_ids, range}, msg_list) {
  const judgeInRange = (msg) => {
    if (!msg.data.send_time) return false
    const now = new Date().getTime()
    return (now - msg.data.send_time) < range * 1000
  }
  return msg_list.filter(v => {
    if (user_ids.includes(v.data.user_id)) {
      if (range) {
        return !judgeInRange(v)
      } else {
        return false
      }
    }
    return true
  })
}